export const API_BASE = 'https://www.tokonex.com/api/src/api';

export function buildApiUrl(path: string): string {
  const trimmed = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE}/${trimmed}`;
}

